// import { Globe } from "lucide-react"

// // AboutPage.jsx
// export const AboutPage = () => {
//     return (
//       <div className="min-h-screen bg-gray-50">
//         {/* Hero Section */}
//         <section className="relative pt-32 pb-48 bg-gradient-to-r from-green-900 to-gray-900">
//           <div className="max-w-7xl mx-auto px-6 text-center">
//             <h1 className="text-5xl font-bold text-white mb-6">Powering the Future Sustainably</h1>
//             <p className="text-xl text-gray-200 max-w-3xl mx-auto">
//               Committed to delivering innovative solar solutions for homes and businesses nationwide.
//             </p>
//           </div>
//         </section>
  
//         {/* Mission Section */}
//         <section className="py-20">
//           <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
//             <div className="space-y-8">
//               <h2 className="text-4xl font-bold text-gray-900">Our Mission</h2>
//               <p className="text-lg text-gray-600">
//                 To accelerate the world's transition to sustainable energy through innovative
//                 solar solutions and exceptional customer experiences.
//               </p>
//               <div className="space-y-6">
//                 <div className="flex items-center space-x-4">
//                   <div className="p-3 bg-green-100 rounded-lg">
//                     <Globe className="h-6 w-6 text-green-600" />
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold">Nationwide Impact</h3>
//                     <p className="text-gray-600">Serving customers across 25+ states</p>
//                   </div>
//                 </div>
//                 {/* More mission points */}
//               </div>
//             </div>
//             <div className="relative h-96 rounded-3xl overflow-hidden shadow-xl">
//               <img 
//                 src="/team-photo.jpg" 
//                 className="w-full h-full object-cover" 
//                 alt="Our Team" 
//               />
//             </div>
//           </div>
//         </section>
  
//         {/* Timeline Section */}
//         {/* <section className="py-20 bg-white">
//           <div className="max-w-7xl mx-auto px-6">
//             <h2 className="text-4xl font-bold text-center mb-16">Our Journey</h2>
//             <div className="relative pl-8 border-l-2 border-green-100 space-y-16">
//               {timelineItems.map((item) => (
//                 <div key={item.year} className="relative pl-8">
//                   <div className="absolute w-4 h-4 bg-green-600 rounded-full -left-[9px] top-2" />
//                   <h3 className="text-2xl font-bold text-gray-900 mb-4">{item.year}</h3>
//                   <p className="text-gray-600 max-w-2xl">{item.description}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section> */}
//       </div>
//     )
//   }

  import React from 'react';
import { 
  Sun, 
  Building, 
  Target, 
  Eye, 
  Truck, 
  Database, 
  Handshake, 
  HeartHandshake,
  CheckCircle
} from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import ja from '../assets/ja.png'
import jinko from '../assets/jinko.png'
import trina from '../assets/download.png'
import longi from '../assets/longi.png'
import rec from '../assets/rec.png'
import canadian from '../assets/canadian.png'
import astro from '../assets/astron.jpeg'
import solis from '../assets/solis.png'
import goodwe from '../assets/goodwe.png'
import sungrow from '../assets/sungroq.png'
import fronius from '../assets/fronius.png'
import antai from '../assets/antai.jpeg'
import mibet from '../assets/mibet.jpeg'

const products = [
    {
        brand: 'JA SOLAR',
        name: 'JA SOLAR PANEL',
        image: ja,
        description: 'High-efficiency monocrystalline solar panel',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'LONGI',
        name: 'LONGI SOLAR PANEL',
        image: longi,
        description: 'Premium performance solar modules',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'TRINA SOLAR',
        name: 'TRINA SOLAR PANEL',
        image: trina,
        description: 'Advanced solar technology panel',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'REC',
        name: 'REC SOLAR PANELS',
        image: rec,
        description: 'Cost-effective solar solution',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'JINKO',
        name: 'JINKO SOLAR PANELS',
        image: jinko,
        description: 'Industry-leading solar panels',
        category: 'SOLAR PANELS'
      },
    //   {
    //     brand: 'CANADIAN',
    //     name: 'CANADIAN SOLAR PANELS',
    //     image: canadian,
    //     description: 'Industry-leading solar panels',
    //     category: 'SOLAR PANELS'
    //   },
    //   {
    //     brand: 'ASTRONERGY',
    //     name: 'ASTRONERGY SOLAR',
    //     image: astro,
    //     description: 'High-quality solar modules',
    //     category: 'SOLAR PANELS'
    //   }
    
]

export const AboutPage = () => {
  const features = [
    {
      icon: <Building className="w-6 h-6" />,
      title: "Experienced Team",
      description: "Our talented professionals never compromise on quality and service. We rigorously select suppliers to maintain your trust in our products."
    },
    {
      icon: <CheckCircle className="w-6 h-6" />,
      title: "Quality Assurance",
      description: "At Krikosh, you'll find reliable and effective products that meet the highest standards of quality."
    },
    {
      icon: <HeartHandshake className="w-6 h-6" />,
      title: "Customer First",
      description: "We prioritize customer satisfaction and building long-term relationships with both suppliers and customers."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
        <Header />
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-green-600 to-green-500 text-white">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative">
          <div className="max-w-3xl">
            <h1 className="text-4xl font-bold mb-6">Why Choose Us</h1>
            <p className="text-lg opacity-90">
              With an experienced team of talented professionals, we never compromise on the quality 
              and service of our work. We choose our suppliers upon a rigorous criterion so that your 
              trust in us and the products we offer you is never compromised.
            </p>
          </div>
        </div>
      </div>

      {/* Mission & Vision Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <Target className="w-8 h-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-bold">Our Mission</h2>
            </div>
            <p className="text-gray-600">
              At Krikosh, our mission is to take action on the climate crisis by making renewable 
              energy as accessible as possible. By offering solar panel installation kits in a fast 
              and efficient manner, we aim to help installers make Australian homes solar-powered.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <Eye className="w-8 h-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-bold">Our Vision</h2>
            </div>
            <p className="text-gray-600">
              Krikosh's vision is to create long-lasting business relationships with our suppliers 
              and customers. That's why we place great emphasis on the quality of services we offer. 
              We want you to be stress-free and trust Krikosh as the one-stop solution.
            </p>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="bg-green-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-green-600 mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Warehouses Section */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="flex-1">
            <div className="flex items-center mb-6">
              <Truck className="w-8 h-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-bold">Warehouses in Every State</h2>
            </div>
            <p className="text-gray-600 mb-6">
              With distribution centres located in Sydney, Melbourne, Brisbane, Perth and Adelaide, 
              we can even offer same-day delivery for metro areas. Our well-developed supply chain 
              ensures that you can get your products without any delays.
            </p>
            <div className="flex items-center mb-6">
              <Database className="w-8 h-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-bold">Advanced Technology</h2>
            </div>
            <p className="text-gray-600">
              At Krikosh, we are always looking at ways to integrate technology in our business. 
              With continued investment in our CRM and ERP system, we aim to create transparency 
              of stock levels at each distribution centre to better serve our customers.
            </p>
          </div>
          <div className="flex-1">
            <img src="/api/placeholder/600/400" alt="Warehouse" className="rounded-2xl shadow-lg" />
          </div>
        </div>
      </div> */}

      {/* Partnerships Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-6">
              <Handshake className="w-8 h-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-bold">Partnerships with Leading Brands</h2>
            </div>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Krikosh has developed relationships with world-class solar panel manufacturers to 
              provide you with a variety of trusted brands to choose from. Our suppliers include 
              Trina Solar, Jinko and many more.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            {products.map((brand) => (
              <div key={brand} className="bg-white p-6 rounded-xl shadow-sm">
                <img src={brand.image} alt="Brand Logo" className="w-full h-auto" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Support Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-green-600 rounded-2xl p-8 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-bold mb-6">Continued Support</h2>
            <p className="text-lg opacity-90">
              At Krikosh, your journey with us doesn't end when you clear your accounts. Our skilled 
              team will always be there for you. If you need help with understanding the manufacturer's 
              warranty, troubleshooting issues or want to learn more about new technologies in the 
              market, Krikosh will be there for you.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
